import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { LinkColumnComponent } from '../link-column/link-column.component';

@Component({
  selector: 'app-product-id-column',
  standalone: true,
  imports: [LinkColumnComponent],
  templateUrl: './product-id-column.component.html',
  styleUrl: './product-id-column.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductIdColumnComponent implements AgRendererComponent {
  readonly productEntityId = signal<string | null>('');
  readonly label = signal<string | null>('');
  readonly routerLink = signal<string[]>([]);

  agInit(params: ICellRendererParams): void {
    this.productEntityId.set(params.data.productEntityId);
    this.label.set(params.data.productEntityId ? params.data.productId : null);
  }

  refresh(params: ICellRendererParams): boolean {
    this.agInit(params);
    return true;
  }
}
